<div class="layout-topbar ">
    <div class="layout-topbar-logo-container">
        <button class="layout-menu-button layout-topbar-action icon-open-sidebar "
            (click)="layoutService.onMenuToggle()">
            <i class="pi pi-bars" style="color: white;"></i>
        </button>
        <img src="assets/6b69e5fc-0d9c-40f3-abfc-62866696e1ad.png" alt="Logo" class="w-40 mt-3 h-36 object-contain rounded-[1.5vw]">

        
    </div>

    <div class="layout-topbar-actions">
        <div class="layout-config-menu">

            <p-overlaybadge [value]="userCredits2()">
                <i class="pi pi-wallet layout-topbar-action" style="color: white;" pTooltip="Vos crédits" tooltipPosition="bottom">
                </i>
            </p-overlaybadge>



            <div class="layout-topbar-menu-content flex flex-row-reverse items-center gap-2 w-full sm:w-auto ">
                <p-overlaybadge *ngIf="unreadCount() > 0" [value]="unreadCount().toString()">
                    <i class="pi pi-bell layout-topbar-action"  (click)="toggleNotifications(op2, $event)"
                        [class.text-blue-500]="unreadCount() > 0" pTooltip="Notifications" tooltipPosition="bottom"></i>
                </p-overlaybadge>
                <i *ngIf="unreadCount() === 0" class="pi pi-bell layout-topbar-action" style="color: white;"
                    (click)="toggleNotifications(op2, $event)" pTooltip="Notifications" tooltipPosition="bottom"></i>
                <p-popover #op2 [style]="{ width: '100vw', maxWidth: '450px', minWidth: '260px', maxHeight: '70vh' }"
                    class="sm:max-w-md w-full" (onShow)="onNotificationsOpened()" (onHide)="onNotificationsClosed()">
                    <div
                        class="flex flex-col sm:flex-row items-center justify-between mb-4 pb-3 border-b border-gray-200 gap-2">
                        <div class="font-semibold text-base sm:text-xl text-gray-800">
                            Notifications
                            <span *ngIf="unreadCount() > 0"
                                class="ml-2 text-xs sm:text-sm bg-blue-500 text-white px-2 py-1 rounded-full">
                                {{ unreadCount() }}
                            </span>
                        </div>
                        <div class="flex gap-2">
                            <button (click)="refreshNotifications()" class="text-xs text-gray-600 hover:text-gray-800"
                                [class.animate-spin]="isLoadingNotifications()" pTooltip="Actualiser">
                                <i class="pi pi-refresh"></i>
                            </button>
                        </div>
                    </div>

                    <div *ngIf="isLoadingNotifications()" class="flex justify-center py-8">
                        <i class="pi pi-spin pi-spinner text-2xl text-blue-500" style="color: white;"></i>
                    </div>

                    <div *ngIf="!isLoadingNotifications()" class="max-h-[60vh] overflow-y-auto px-2">
                        <ng-container *ngIf="hasNotificationsInGroup('today')">
                            <span class="block text-muted-color font-medium mb-3 text-xs uppercase tracking-wide">
                                {{ getGroupTitle('today') }}
                            </span>
                            <ul class="p-0 mx-0 mt-0 mb-6 list-none">
                                <li *ngFor="let notification of getNotificationsForGroup('today')"
                                    class="flex flex-col sm:flex-row items-start py-3 border-b border-gray-100 hover:bg-gray-50 rounded px-2 cursor-pointer transition-colors"
                                    (click)="markNotificationAsRead(notification, $event)"
                                    [class.opacity-60]="notification.is_read">

                                    <div class="w-10 h-10 flex items-center justify-center rounded-full mr-0 sm:mr-3 shrink-0 mb-2 sm:mb-0"
                                        [ngClass]="getNotificationIconClass(notification)">
                                        <i [class]="'pi ' + getNotificationIcon(notification) + ' text-sm'"></i>
                                    </div>

                                    <div class="flex-1 min-w-0">
                                        <div class="font-medium text-sm text-gray-900"
                                            [class.font-bold]="!notification.is_read">
                                            {{ notification.title }}
                                        </div>
                                        <div class="text-xs text-gray-600 mt-1 leading-relaxed">
                                            {{ notification.message }}
                                        </div>
                                        <div class="text-xs text-gray-400 mt-2 flex items-center">
                                            <i class="pi pi-clock mr-1"></i>
                                            {{ formatNotificationTime(notification.created_at) }}
                                            <span *ngIf="!notification.is_read"
                                                class="ml-2 w-2 h-2 bg-blue-500 rounded-full"></span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </ng-container>
                        <!-- Répéter pour les autres groupes (yesterday, this_week, older) avec les mêmes classes responsive -->
                        <ng-container *ngIf="hasNotificationsInGroup('yesterday')">
                            <span class="block text-muted-color font-medium mb-3 text-xs uppercase tracking-wide">
                                {{ getGroupTitle('yesterday') }}
                            </span>
                            <ul class="p-0 mx-0 mt-0 mb-6 list-none">
                                <li *ngFor="let notification of getNotificationsForGroup('yesterday')"
                                    class="flex flex-col sm:flex-row items-start py-3 border-b border-gray-100 hover:bg-gray-50 rounded px-2 cursor-pointer transition-colors"
                                    (click)="markNotificationAsRead(notification, $event)"
                                    [class.opacity-60]="notification.is_read">

                                    <div class="w-10 h-10 flex items-center justify-center rounded-full mr-0 sm:mr-3 shrink-0 mb-2 sm:mb-0"
                                        [ngClass]="getNotificationIconClass(notification)">
                                        <i [class]="'pi ' + getNotificationIcon(notification) + ' text-sm'"></i>
                                    </div>

                                    <div class="flex-1 min-w-0">
                                        <div class="font-medium text-sm text-gray-900"
                                            [class.font-bold]="!notification.is_read">
                                            {{ notification.title }}
                                        </div>
                                        <div class="text-xs text-gray-600 mt-1 leading-relaxed">
                                            {{ notification.message }}
                                        </div>
                                        <div class="text-xs text-gray-400 mt-2 flex items-center">
                                            <i class="pi pi-clock mr-1"></i>
                                            {{ formatNotificationTime(notification.created_at) }}
                                            <span *ngIf="!notification.is_read"
                                                class="ml-2 w-2 h-2 bg-blue-500 rounded-full"></span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </ng-container>
                        <ng-container *ngIf="hasNotificationsInGroup('this_week')">
                            <span class="block text-muted-color font-medium mb-3 text-xs uppercase tracking-wide">
                                {{ getGroupTitle('this_week') }}
                            </span>
                            <ul class="p-0 mx-0 mt-0 mb-6 list-none">
                                <li *ngFor="let notification of getNotificationsForGroup('this_week')"
                                    class="flex flex-col sm:flex-row items-start py-3 border-b border-gray-100 hover:bg-gray-50 rounded px-2 cursor-pointer transition-colors"
                                    (click)="markNotificationAsRead(notification, $event)"
                                    [class.opacity-60]="notification.is_read">

                                    <div class="w-10 h-10 flex items-center justify-center rounded-full mr-0 sm:mr-3 shrink-0 mb-2 sm:mb-0"
                                        [ngClass]="getNotificationIconClass(notification)">
                                        <i [class]="'pi ' + getNotificationIcon(notification) + ' text-sm'"></i>
                                    </div>

                                    <div class="flex-1 min-w-0">
                                        <div class="font-medium text-sm text-gray-900"
                                            [class.font-bold]="!notification.is_read">
                                            {{ notification.title }}
                                        </div>
                                        <div class="text-xs text-gray-600 mt-1 leading-relaxed">
                                            {{ notification.message }}
                                        </div>
                                        <div class="text-xs text-gray-400 mt-2 flex items-center">
                                            <i class="pi pi-clock mr-1"></i>
                                            {{ formatNotificationTime(notification.created_at ) }}
                                            <span *ngIf="!notification.is_read"
                                                class="ml-2 w-2 h-2 bg-blue-500 rounded-full"></span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </ng-container>
                        <ng-container *ngIf="hasNotificationsInGroup('older')">
                            <span class="block text-muted-color font-medium mb-3 text-xs uppercase tracking-wide">
                                {{ getGroupTitle('older') }}
                            </span>
                            <ul class="p-0 m-0 list-none">
                                <li *ngFor="let notification of getNotificationsForGroup('older')"
                                    class="flex flex-col sm:flex-row items-start py-3 border-b border-gray-100 hover:bg-gray-50 rounded px-2 cursor-pointer transition-colors"
                                    (click)="markNotificationAsRead(notification, $event)"
                                    [class.opacity-60]="notification.is_read">

                                    <div class="w-10 h-10 flex items-center justify-center rounded-full mr-0 sm:mr-3 shrink-0 mb-2 sm:mb-0"
                                        [ngClass]="getNotificationIconClass(notification)">
                                        <i [class]="'pi ' + getNotificationIcon(notification) + ' text-sm'"></i>
                                    </div>

                                    <div class="flex-1 min-w-0">
                                        <div class="font-medium text-sm text-gray-900"
                                            [class.font-bold]="!notification.is_read">
                                            {{ notification.title }}
                                        </div>
                                        <div class="text-xs text-gray-600 mt-1 leading-relaxed">
                                            {{ notification.message }}
                                        </div>
                                        <div class="text-xs text-gray-400 mt-2 flex items-center">
                                            <i class="pi pi-clock mr-1"></i>
                                            {{ formatNotificationTime(notification.created_at) }}
                                            <span *ngIf="!notification.is_read"
                                                class="ml-2 w-2 h-2 bg-blue-500 rounded-full"></span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </ng-container>
                        <div *ngIf="!hasNotificationsInGroup('today') && 
                                   !hasNotificationsInGroup('yesterday') && 
                                   !hasNotificationsInGroup('this_week') && 
                                   !hasNotificationsInGroup('older')" class="text-center py-8">
                            <i class="pi pi-bell-slash text-4xl text-gray-300 mb-4"></i>
                            <p class="text-gray-500 text-sm">Aucune notification</p>
                        </div>
                    </div>
                </p-popover>
            </div>


            <button type="button" class="layout-topbar-action block lg:hidden" (click)="toggleProfile(op3, $event)"
                pTooltip="Profil" tooltipPosition="bottom">
                <i class="pi pi-user" style="color: white;"></i>
            </button>

            <div class="relative">
                <app-configurator />
            </div>
        </div>

        <div class="layout-topbar-menu hidden lg:block">
            <div class="layout-topbar-menu-content">

                <p-popover #op3 [style]="{ width: '300px' }">
                    <div class="flex items-center justify-between mb-6">
                        <div class="font-semibold text-xl">Mon Profil</div>
                        <button class="p-button p-component p-button-text" (click)="logout()">
                            <span class="p-button-label">Déconnexion</span>
                        </button>
                    </div>

                    <div class="space-y-3 mb-4">
                        <div class="flex items-center">
                            <div class="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mr-3">
                                @if (currentUser?.image_profile) {
                                <img [src]="currentUser?.image_profile" alt="User Avatar"
                                    class="w-full h-full object-cover rounded-full">
                                } @else {
                                <span class="text-white font-medium">
                                    {{ (currentUser?.first_name || 'U').charAt(0).toUpperCase() }}{{
                                    (currentUser?.last_name || '').charAt(0).toUpperCase() }}
                                </span>
                                }
                            </div>
                            <div>
                                <div class="font-medium text-gray-900">{{ currentUser?.first_name }} {{
                                    currentUser?.last_name }}</div>
                                <div class="text-sm text-gray-500">{{ currentUser?.email }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="space-y-2">
                        <button class="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded"
                            (click)="navigateTo('profil')">
                            <i class="pi pi-user mr-2"></i>
                            Mon profil
                        </button>
                        <button class="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded"
                            (click)="navigateTo('historique')">
                            <i class="pi pi-fw pi-history"></i>
                            Historique
                        </button>
                        <button class="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded"
                            (click)="navigateTo('investissement')">
                            <i class="pi pi-fw pi-money-bill"></i>
                            Projets
                        </button>
                    </div>
                </p-popover>
            </div>
        </div>
    </div>
</div>